var _path, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInterfaceInfoSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outline_art_-_SVG_EXPORT",
    "data-name": "outline art - SVG EXPORT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.07,32c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Zm0-26c-6.62,0-12,5.38-12,12s5.38,12,12,12,12-5.38,12-12-5.38-12-12-12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.07,
    cy: 11.63,
    r: 1.85
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.53,
    y: 15.59,
    width: 3.1,
    height: 10.63
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInterfaceInfoSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-interface-info-small.de6c41a33fdb779ec2a0292a1b319e01.svg";